// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DrawerFooter{display:flex;justify-content:flex-end;gap:10px;align-items:center}", ""]);
// Exports
module.exports = exports;
